import $http from '../services/AxiosInstance';
import { IProduct } from '../types/products.type';


interface Params {
  page?: number;
  search?: string;
  riskType?: string;
  subAssetId?: number;
  deleted?: boolean;
}

class ProductsRepository {
  static async getProducts(params: Params = {}) {
    try {
      let url = `/products/pro`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.riskType) {
        url += `&riskType=${params.riskType}`;
      }
      if (params.subAssetId) {
        url += `&subAssetId=${params.subAssetId}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createProduct(data: IProduct): Promise<IProduct> {
    try {
      const response = await $http.post('/products', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateProduct(data: IProduct): Promise<IProduct> {
    try {
      const response = await $http.patch(`/products/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteProduct(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/products/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreProduct(id: number): Promise<number> {
    try {
      const response = await $http.post(`/products/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default ProductsRepository;
